import styles from "./FormSection.module.css";

function FormSection({ section, children }) {
  const { heading, id } = section;

  return (
    <div className={styles.formSection} id={id}>
      <h3 className={styles.sectionTitle}>{heading}</h3>
      {children}
    </div>
  );
}

export default FormSection;
